export default __webpack_public_path__ + "static/media/saa-03.f5431d27.jpg";